/**
 * The tabs of a session's page. Each value is the URL segment after
 * `/sessions/:sessionId` that opens the tab: `SessionsRoutes` registers the
 * tab's route at that segment, and the tab strip reads it back to mark the
 * active tab.
 */
export enum SessionTab {
  Topics = "topics",
  Sources = "sources",
  Events = "events",
  Metrics = "metrics",
  Actions = "actions",
  Agents = "agents",
  Summary = "summary",
  Details = "details",
}
